const index_EE = document.getElementById('index_EE');

const DeleteEE = () => {
  if (index_EE) {
    const button = document.getElementById('modifier');
    const eye_icon = document.querySelectorAll('#eye');
    const trash_icon = document.querySelectorAll('#trash');

    button.addEventListener('click', () => {
      Array.prototype.forEach.call(eye_icon, function (eye) {
        eye.classList.toggle("hidden");;
      });
      Array.prototype.forEach.call(trash_icon, function (trash) {
        trash.classList.toggle("hidden");;
      })
      if (button.innerHTML === "Modifier") {
        button.innerHTML = "Annuler";
      } else {
        button.innerHTML = "Modifier";
      }
    })
  };
}

export { DeleteEE };
